import { Button, TextField } from '@efexteam/components';
import { useTranslation } from 'react-i18next';
import { ultraShortLength } from '../../../constants/inputsLength';
import { AuthLayout } from '../../../components/auth/AuthLayout';
import { AuthFormContainer } from '../../../components/auth/AuthFormContainer';
import useLegacyForgotPassword from '../hooks/useLegacyForgotPassword';

const LegacyResetForm = () => {
  const { t } = useTranslation();

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
    success,
    error,
    isLoading,
    handleBackToLogin,
    onSubmit,
    getFieldError,
  } = useLegacyForgotPassword();

  const headerActions = (
    <Button
      appearance="secondary"
      variant="outlined"
      color="primary"
      onClick={handleBackToLogin}
    >
      {t('backToLogin')}
    </Button>
  );

  return (
    <AuthLayout headerActions={headerActions}>
      <AuthFormContainer
        title={t('forgotPasswordTitle')}
        description={t('forgotPasswordDescription') as string}
        onSubmit={handleSubmit(onSubmit)}
        submitButtonText={t('forgotPasswordSubmitButton')}
        submitButtonDisabled={!isValid || success}
        isLoading={isLoading}
        loadingText={t('forgotPasswordSubmittingButton') as string}
        successMessage={
          success ? (t('forgotPasswordSuccessMessage') as string) : undefined
        }
        errorMessage={error}
      >
        <TextField
          name="email"
          inputRef={register('email').ref}
          onChange={register('email').onChange}
          onBlur={register('email').onBlur}
          fullWidth
          label={t('forgotPasswordEmailLabel')}
          placeholder={t('forgotPasswordEmailPlaceholder') as string}
          error={!!errors.email}
          helperText={getFieldError('email')}
          disabled={isLoading}
          slotProps={{
            htmlInput: { maxLength: ultraShortLength },
          }}
        />
      </AuthFormContainer>
    </AuthLayout>
  );
};

export default LegacyResetForm;
